import * as React from "react"
import { MdNorthEast as Arrow } from "react-icons/md"
import { ButtonStyles } from "./ButtonStyles"

const Button = ({ text, to, href, as, arrow, onClick, noArrow, ghost }) => {
  const showArrow = !noArrow && (arrow || to || href)
  const className = `btn${ghost ? " btn--ghost" : ""}${
    showArrow ? " btn--arrow" : ""
  }`

  return (
    <ButtonStyles
      className={className}
      as={as || (href ? "a" : undefined)}
      to={to}
      href={href}
      onClick={onClick}
    >
      {text}
      {showArrow ? (
        <span className="btn__arrow">
          <Arrow />
        </span>
      ) : null}
    </ButtonStyles>
  )
}

export default Button
